import http from "infra/http";
import { useQuery } from "react-query";
import { VariacaoUnidade } from "./typings";

function useVariacoesUnidades(id?: string, enabled: boolean = true) {
  return useQuery(`/v1/arrecadacao/${id}/variacao-unidades`, async () => {
    const { data } = await http.get<VariacaoUnidade[]>(`/v1/arrecadacao/${id}/variacao-unidades`);
    return data;
  }, {
    enabled: !!id && enabled,
  });
}

export default useVariacoesUnidades;
